// extracted by mini-css-extract-plugin
module.exports = {"red":"area_red_15z_p"};